export type DocumentPermissionType = "Read" | "Write" | "Delete" | "Share"

export const DOCUMENT_PERMISSION_OPTIONS: DocumentPermissionType[] = [
  "Read",
  "Write",
  "Delete",
  "Share",
]
